const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SocialSecurityNo\\.[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_2[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_2[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_2[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_2[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_2[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_2[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_2[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [       
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].B1[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis5[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].B2[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis5[3]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].B3[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis5[1]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].B4[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis5[2]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].Specify[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis5[2]",
        },        
    ]

}

export default ssn ;